var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17166",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17166",
    transform: "translate(17899 -8717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "url",
    transform: "translate(-17899 8723.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21657",
    "data-name": "\\u30D1\\u30B9 21657",
    d: "M20.35,21.759H17.956a1.2,1.2,0,1,1,0-2.394H20.35a5.985,5.985,0,1,0,0-11.97H17.956a1.2,1.2,0,1,1,0-2.394H20.35a8.379,8.379,0,1,1,0,16.759Zm-9.576,0H8.379A8.379,8.379,0,1,1,8.379,5h2.394a1.2,1.2,0,1,1,0,2.394H8.379a5.985,5.985,0,1,0,0,11.97h2.394a1.2,1.2,0,1,1,0,2.394Z",
    transform: "translate(0 -5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21658",
    "data-name": "\\u30D1\\u30B9 21658",
    d: "M16.379,13.394H9.2A1.2,1.2,0,1,1,9.2,11h7.182a1.2,1.2,0,1,1,0,2.394Z",
    transform: "translate(1.576 -3.818)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15323",
    "data-name": "\\u9577\\u65B9\\u5F62 15323",
    width: 29,
    height: 30,
    transform: "translate(-17899 8717)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkButton);
export default __webpack_public_path__ + "static/media/linkButton.5177f8f492e4a8eb605154c1a8dff63e.svg";
export { ForwardRef as ReactComponent };